import Input from "../../customhtmlcomponents/Input";
import Button from "../../customhtmlcomponents/Button";
import React, { FC, useState } from "react";
import generator from "../../../utility/passwordGen";
import { useForm } from "react-hook-form";
import { RegisterForeningData } from "../types";
import axios from "../../../services/ApiConfig";
import { AxiosResponse } from "axios";
import { IGenerateForeningPanelProps, ResponseData } from "./types/types";
import { URLS } from "../../../utility/UrlConstants";

const GenerateForeningPanel: FC<IGenerateForeningPanelProps> = ({
  state,
  dispatch,
  setModal,
  message,
}: IGenerateForeningPanelProps) => {
  const { register, setValue, handleSubmit } = useForm<RegisterForeningData>();
  const generatePassword = () => {
    setValue(
      "opprettForeningsPassord",
      generator.generate({ length: 6, numbers: true, uppercase: true })
    );
  };
  const labelopts = { labelOn: true, defaultLabelStyle: true };
  const [processing, isProcessing] = useState(false);
  const processingStyle = `${
    processing ? "hover:opacity-100 hover:cursor-not-allowed" : null
  } bg-sk-primary-blue disabled:bg-gray-400 disabled:text-sk-button-unselected}`;
  const disabledStyle = processing ? true : undefined;
  const active = true;
  const submitForening = handleSubmit(
    ({
      opprettForeningsNavn,
      opprettForeningsNummer,
      opprettForeningsPassord,
      viewer
    }) => {
      isProcessing(true);
      axios
        .post(
          URLS.ADMIN_OPPRETT_FORENING_POST,
          {
            opprettForeningsNummer,
            opprettForeningsNavn,
            opprettForeningsPassord,
            active,
            viewer
          },
          {
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
            },
          }
        )
        .then((response: AxiosResponse<ResponseData>) => {
          JSON.stringify(response.data.body);
          if (response.data) {
            let mess = response.data;
            message({
              body: mess,
            });
            setModal(true);
            setTimeout(() => setModal(false), 7000);
          }
          dispatch({
            type: "setCurrentForening",
            //@ts-ignore
            payload: {
              foreningsNummer: opprettForeningsNummer,
              foreningsNavn: opprettForeningsNavn,
              active: true,
            },
          });
          dispatch({ type: "setMatch", payload: true });
        })
        .catch((error) => {
          console.log("error", error.response);
          let mess = error?.response?.data;
          message({
            body: mess ?? "Noe gikk dessverre galt. Vennligst prøv igjen.",
          });
          setModal(true);
          setTimeout(() => setModal(false), 5000);
        })
        .then(() => isProcessing(false));
    }
  );
  return (
    <div className="bg-sk-button-selected border-2 border-sk-secondary-blue shadow-xl mx-6 p-4  h-3/3 rounded mb-3 2xl:mb-0">
      <h1 className="text-black text-center text-2xl font-bold mt-2py-2">
        Opprett forening
      </h1>
      <form onSubmit={submitForening}>
        <Input
          labelopts={labelopts}
          name="opprettForeningsNummer"
          label="Foreningsnummer"
          placeholder="Foreningsnummer"
          id="opprettForeningsNummer"
          ref={register}
          required
          type="number"
          min="0"
        />
        <Input
          labelopts={labelopts}
          name="opprettForeningsNavn"
          required
          placeholder="Foreningsnavn"
          label="Foreningsnavn"
          id="opprettForeningsNavn"
          ref={register}
          className="w-1/2"
        />
        <Input
          labelopts={labelopts}
          name="opprettForeningsPassord"
          required
          placeholder="Passord"
          label="Opprett passord"
          id="opprettForeningsPassord"
          ref={register}
        />

        <Input
          labelopts={labelopts}
          name="viewer"
          label="Kan lese alle rapporter"
          id="viewer"
          type="checkbox"
          ref={register}
          checkbox={true}
        />

        {/* <Input
          name="active"
          label="Aktiv"
          id="active"
          type="checkbox"
          ref={register}
          labelopts={labelopts}
          checkbox={true}
        /> */}

        <div className="grid grid-cols-4 mt-4 place-content-evenly">
          <Button
            onClick={generatePassword}
            type="button"
            className={processingStyle}
            disabled={disabledStyle}
          >
            Generer passord
          </Button>
          <Button
            type="submit"
            className={processingStyle}
            disabled={disabledStyle}
          >
            Opprett forening
          </Button>
        </div>
      </form>
    </div>
  );
};
export default GenerateForeningPanel;
